SlideView           = require("views/slide")
ScormAttempt        = require "models/scormAttempt"
Device              = require "lib/device"
Flags               = require "constants/feature-flags"
{ Session, Lesson } = Application.actions()
{ openExternalUrl } = require("utils/open-external-url")
ScormAPI            = require "./ed_scorm_player"

class SCORMView extends SlideView
  template: require("./template")
  events: ->
    "iostap .exit-btn": "onClickContinue"

  initialize: ->
    super

    Session.get (err, { firstName, lastName, email, name, userId }) =>
      studentName = if not window.ED_LMS_PREVIEW  then ((firstName || '') + ' ' + (lastName || '')).trim() || name || email || '' else "John Doe"
      studentId = if not window.ED_LMS_PREVIEW  then userId else 'fakeAdminId'
      @scormAttempt = new ScormAttempt("lessonId", false, studentName, studentId, @options.previousAttempt)

    @isLastSlide  = @options.isLastSlide
    @lessonContainer = document.querySelector('#lesson-slides')

  processIframeMessage: (event) ->
    if event?.data?.match?("window.SCORMED")
      eval(event.data)

  beforeShow: ->
    scormIframe = @findOne("iframe.scorm-object")
    scormIframe.onload = () =>
      @findOne("#loading-wrapper")?.classList.add('hidden')
      # need to modify all <a href/> to call a special function to make redirection work
      @checkForLinksPollTimer = window.setInterval =>
        if scormIframe.contentDocument
          links = scormIframe.contentDocument.querySelectorAll('a[href]:not([data-modified])')
          for link in links
            # Three unique cases found thus far, example of a SCORM index link: /external-packages/23ddf0df-bf88-303f-67ac-70765fff720c.zip_external_package_temp/index.html
            # 1. href="../../Clients/CPZ/Courses/GLE/_Asset_Library/gle/docs/CPZ_eng_Antibribery.pdf" -> external
            # 2. href="#section" -> internal
            # 3. href="next" -> internal
            # iframeUrl = http://localhost:8082/external-packages/....zip_external_package_temp/index.html
            iframeUrl = scormIframe.contentDocument.location.origin + scormIframe.contentDocument.location.pathname
            # omit the last path ../index.html to get this http://localhost:8082/external-packages/....zip_external_package_temp
            iframeUrl = iframeUrl.substring(0, iframeUrl.lastIndexOf('/'))
            if link.href.startsWith(iframeUrl) # skip internal links
              continue
            link.dataset.modified = true
            link.onclick = (e) ->
              openExternalUrl(e.currentTarget.href)
      , 500

    position = @options.data.button?.position?.toLowerCase() or "none"
    @setState written.hyphenCase(position), "exit-btn"

    @trigger "ui", { lightbox: @options.data.background or true, fullscreen: true }

    @beforeResize()
    @onResize()

  beforeHide: ->
    @lessonContainer.style.position = null
    @lessonContainer.style.width = null
    @lessonContainer.style.height = null
    @trigger "ui", { lightbox: false, fullscreen: false }

  show: ->
    @stopped = false
    position = @options.data.button?.position?.toLowerCase() or "none"
    @setState written.hyphenCase(position), "exit-btn"

    @listenTo this, "beforeResize", @beforeResize
    @listenTo this, "resize", @onResize

    if !@options.notInteractable
      @initSCORM()

    window.addEventListener("message", @processIframeMessage , false)

  onRefresh: ->
    @beforeShow()
    super

  beforeResize: ->
    # position absolute/relative might cause layout issues inside the scorm iframe. Position fixed makes sure the iframe window doesn't move.
    @lessonContainer.style.position = 'fixed'
    @lessonContainer.style.width = @lessonContainer.parentElement.offsetWidth + "px"
    @lessonContainer.style.height = @lessonContainer.parentElement.offsetHeight + "px"

  onResize: ->
    if @currentState["exit-btn"] is "below"
      button = @findOne(".exit-btn")
      iframe = @findOne(".scorm-object")

      iframe.style.bottom = "#{button.offsetHeight}px"
      iframe.style.height =
        "#{iframe.parentNode.offsetHeight - button.offsetHeight}px"

  stopSCORM: ->
    return if @stopped
    @stopped = true
    window.API?.LMSFinish()
    window.removeEventListener("message", @processIframeMessage , false)
    window.clearInterval(@checkForLinksPollTimer)
    attemptData = @scormAttempt.attemptData()
    raw = attemptData?["cmi.core.score.raw"]?.value
    tot = attemptData?["cmi.core.score.max"]?.value

    score = if raw and tot
      # use package score
      parseInt(raw) * 1.0 / parseInt(tot)
    else
      # use 100 for success and 0 for not success
      if attemptData?.success then 1 else 0

    Session.get (err, { attempt }) =>
      interaction =
        id:              @options.id
        name:            @options.name
        type:            @options.type
        slideData:       @options.data
        scormData:       attemptData
        attempt:         attempt
        correct:         attemptData?.success
        answerDetails:   []
        metadata:        @options.metadata
        isScormAttempt:  true
        score:           score
        isCompleted:     attemptData?.success
        isRequiredForLessonCompletion: @options.data.isRequiredForLessonCompletion
        configuration:   @options.data?.challenge_configuration

      @lesson.processInteraction(interaction)

      if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW
        return
      else if @isLastSlide
        Lesson.complete()
        @exit()
      else
        @next()


  onClickContinue: ->
    @stopSCORM()
    if window.ED_LMS_PREVIEW or window.ED_PUBLIC_PREVIEW
      @next()

  serialize: ->
    data = super
    sandboxedFeatures = [ "allow-scripts", "allow-same-origin", "allow-modals", "allow-popups", "allow-popups-to-escape-sandbox", "allow-forms", "allow-downloads" ]

    data.allowedSandboxedFeatures = sandboxedFeatures.join(" ")
    data

  initSCORMResource: ->
    data     = @serialize()
    resource = data.package
    if !resource or resource is "scorm/scorm.zip"
      return

    @findOne(".scorm-object").src = resource
    @findOne("#loading-wrapper")?.classList.remove('hidden')

    window.SCORMED = LMSFinish: (data) =>
      @scormAttempt.processScormPlayerData(data)
      @stopSCORM()

  initSCORM: ->
    scormData  = @scormAttempt.initialData()
    callbacks  = success: (success) => @initSCORMResource() if success
    # Required to conform to the SCORM protocol.
    # It is the way the SCORM package on the iframe will actually find
    # a SCORM API to communicate with
    scormAPI = new ScormAPI("lesson", "LID", scormData, callbacks)
    window.API = scormAPI

module.exports = SCORMView
